/*
 * @Author: POPE
 * @Date: 2020-03-18 17:31:43
 * @LastEditors: POPE
 * @LastEditTime: 2020-07-06 21:15:29
 * @Description: 国际化
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n'; // 国际化插件
//element语言包
import ElementLocale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en';
import cnLocale from 'element-ui/lib/locale/lang/zh-CN';

// formMarking语言包
import enLocaleForFormMarking from './../components/views/workFlow/componentsFormMaking/src/lang/en-US';
import cnLocaleForFormMarking from './../components/views/workFlow/componentsFormMaking/src/lang/zh-CN';

import { Common } from 'js/class/Common';

console.log(ElementLocale);

Vue.use(VueI18n);

const DEFAULT_LANG = localStorage.getItem('locale') || 'cn';
const LOCALE_KEY = 'localeLanguage';

let guid = Common.getInstance().randomn(10);
// let zhLang = require(`locale/lang/zh.json`)
// let enLang = require(`locale/lang/en.json`)
const messages = {
  cn: {
    ...cnLocale,
    ...cnLocaleForFormMarking,
  },
  en: {
    ...enLocale,
    ...enLocaleForFormMarking,
    文件大小: 'File Size',
    前: 'Front',
    后: 'Back',
    左: 'Left',
    右: 'Right',
    上: 'Up',
    下: 'Down',
    显示拼装编号: 'Show Assembly Number',
    显示物料名称: 'Show Material Name',
    属性: 'Properties',
    结构树: 'Structure Tree',
    输入关键字搜索: 'Enter Keywords to Search',
    测量: 'Close Measurement',
    长度: 'Length',
    标高: 'Elevation',
    关闭测量: 'Close Measurement',
    搜索: 'Search',
    属性搜索: 'Search Properties',
    属性名: 'Property Name',
    属性值: 'Property Value',
    选择所有: 'Select All',
    全词匹配: 'Exact Match',
    区分大小写: 'Case Sensitive',
    '选填，全词匹配且区分大小写': 'Optional, exact match and case sensitive',
    必填: 'Required',
    空: 'Empty',
    暂无更多数据: 'No more data available',
    漫游: 'Roam',
    漫游操作说明: 'Roaming Operation Instructions',
    前后左右: 'Front, Back, Left, Right',
    向上或者向下: 'Up or Down',
    调整速度: 'Adjust Speed',
    我知道了: 'Got It',
    移动速度: 'Movement Speed',
    剖切: 'Section',
    恢复默认: 'Restore Default',
    退出构件剖切: 'Exit Component Sectioning',
    全屏: 'Full Screen',
    渲染模型中: 'Rendering Model',
    完整显示: 'Show All',
    提示: 'Tip',
    '是否访问全部模型，若模型太大可能出现加载失败的情况':
      'Access all models, if the model is too large,loading may fail',
    取消: 'Cancel',
    确认: 'Confirm',
    准备: 'Preparing',
    或者: 'Or',
    显示全部:'Show All',
    构件信息:'Component information',
    结构:'Structure',
    获取模型文件中:'Obtaining model files',
    名称切换:'Name switching',
    退出全屏:'Exit Full Screen',
    构件剖切:'Component Sectioning',
    请输入属性值:'Please enter attribute values',
    搜索中:'Searching',
    获取模型属性中:'Obtaining model properties',
  },
};

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages,
  silentTranslationWarn: true,
  fallbackLocale: DEFAULT_LANG,
});
ElementLocale.i18n((key, value) => i18n.t(key, value));

// export const setup = lang => {
//   if (lang === undefined) {
//     lang = window.localStorage.getItem(LOCALE_KEY)
//     if (messages[lang] === undefined) {
//       lang = DEFAULT_LANG
//     }
//   }
//   window.localStorage.setItem(LOCALE_KEY, lang)

//   Object.keys(messages).forEach(lang => {
//     document.body.classList.remove(`lang-${lang}`)
//   })
//   document.body.classList.add(`lang-${lang}`)
//   document.body.setAttribute('lang', lang)

//   Vue.config.lang = lang
//   i18n.locale = lang
// }

export default i18n;
